import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    flag: String,
    variant: { type: String, default: "test" },
    add: String,
    remove: String,
  }

  connect() {
    this.unsubscribeFeatureFlags = posthog.onFeatureFlags(() => {
      const variant = posthog.getFeatureFlag(this.flagValue)

      if (this.isActive(variant)) {
        if (this.addValue) this.element.classList.add(...this.addValue.split(" "))
        if (this.removeValue) this.element.classList.remove(...this.removeValue.split(" "))
      }
    })
  }

  disconnect() {
    this.unsubscribeFeatureFlags?.()
  }

  isActive(variant) {
    if (variant === this.variantValue) return true
    if (this.variantValue === "control") {
      if (variant === undefined || variant === "control") return true
    }
  }
}
